import { isServerAlive } from "services"

const testReachablity = async () => {
  try {
    await isServerAlive()

    return true
  } catch (err) {
    return false
  }
}

export default testReachablity